"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_TRENDS_HASH = void 0;
exports.GET_TRENDS_HASH = `
  {
    trends
  }
`;
//# sourceMappingURL=trends-queries.js.map